var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiscellaneousActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8814 15.3708V13.6278C14.8814 12.2283 16.0171 11.0934 17.4166 11.0934H21.6416V5.06135C21.6416 3.37002 20.2716 2 18.581 2H5.06062C3.37002 2 2 3.37002 2 5.06135V23.938C2 25.6286 3.37002 26.9986 5.06062 26.9986H18.581C20.2716 26.9986 21.6416 25.6286 21.6416 23.938V17.9059H17.4166C16.0163 17.9059 14.8814 16.771 14.8814 15.3708Z",
    fill: "#F7FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7232 11.8584H17.4186C16.4429 11.8584 15.6484 12.6521 15.6484 13.6279V15.3708C15.6484 16.3473 16.4429 17.141 17.4186 17.141H21.7232C22.6997 17.141 23.4934 16.3473 23.4934 15.3708V13.6279C23.4934 12.6521 22.699 11.8584 21.7232 11.8584ZM18.1998 15.5204C17.636 15.5204 17.1799 15.0635 17.1799 14.4997C17.1799 13.9359 17.636 13.479 18.1998 13.479C18.7636 13.479 19.2205 13.9366 19.2205 14.4997C19.2205 15.0627 18.7636 15.5204 18.1998 15.5204Z",
    fill: "#F7FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2051 5.20713C28.2051 4.73989 27.8248 4.35962 27.3583 4.35962H26.5108C26.0429 4.35962 25.6641 4.73989 25.6641 5.20713V6.80708H28.2059L28.2051 5.20713Z",
    fill: "#F7FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1016 7.69141V23.3276C25.1016 23.3276 25.8179 24.7249 26.3935 25.4899V26.456C26.3935 26.7567 26.6367 26.9999 26.9366 26.9999C27.2373 26.9999 27.4805 26.7567 27.4805 26.456V25.4899C28.0546 24.7249 28.7716 23.3276 28.7716 23.3276V7.69141H25.1016Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneousActivity);
export default __webpack_public_path__ + "static/media/Miscellaneous_Activity.b032c6db4939dd9fad19f4648cecef9a.svg";
export { ForwardRef as ReactComponent };